import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  updateActiveUsers,
  updateMonitoringCountries,
} from "./store/UserSlice";
import { useGetSanctionBodies } from "./api/settings/settings-api";
import { updateSanctionBodies } from "./store/SettingsSlice";
import { useGetMonitoringCountries, useGetUsers } from "./api/profile";

interface SanctionsDataProviderProps {
  children: React.ReactNode;
}

const SanctionsDataProvider: React.FC<SanctionsDataProviderProps> = ({ children }) => {
  const dispatch = useDispatch();
 
  const { data: sanctionbodyResponse } = useGetSanctionBodies();
  const { data: monitoringCountryCodes, isSuccess } = useGetMonitoringCountries();
  const { data: usersData, isLoading: usersDataLoading } = useGetUsers();
 
  useEffect(() => {
    if (usersData && !usersDataLoading) {
      dispatch(updateActiveUsers(usersData));
    }
  }, [usersData, usersDataLoading, dispatch]);
 
  useEffect(() => {
    if (isSuccess && monitoringCountryCodes?.countryCodes) {
      dispatch(updateMonitoringCountries(monitoringCountryCodes.countryCodes));
    }
  }, [monitoringCountryCodes, isSuccess, dispatch]);
 
  useEffect(() => {
    if (
      sanctionbodyResponse &&
      Array.isArray(sanctionbodyResponse.sanctionBodies) &&
      sanctionbodyResponse.sanctionBodies.length > 0
    ) {
      dispatch(updateSanctionBodies(sanctionbodyResponse.sanctionBodies));
    }
  }, [sanctionbodyResponse, dispatch]);
 
  return <>{children}</>;
};
 
export default SanctionsDataProvider;